var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',[_c('div',{staticClass:"text-h4 text-md-h3 text-center"},[_c('span',{staticClass:"font-secondary"},[_vm._v(" Política de Privacidade ")])]),_c('PolicyPrivacyWidget',{staticClass:"mt-10 font-secondary"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }